import dayjs, { type Dayjs } from "dayjs";
import { redirect } from "react-router-dom";
import { createFinanceReportPeriod } from "../hooks/financeReportAutoRefresh";

export type FinancePeriod = {
  year: number;
  month: number;
  period: Dayjs;
};

export function resolveFinancePeriodFromUrl(
  url: URL,
  now = dayjs(),
): FinancePeriod & { needsCanonicalRedirect: boolean } {
  const yearParam = url.searchParams.get("year");
  const monthParam = url.searchParams.get("month");
  const parsedYear = yearParam == null ? NaN : Number(yearParam);
  const parsedMonth = monthParam == null ? NaN : Number(monthParam);
  const year = Number.isFinite(parsedYear) ? parsedYear : now.year();
  const month = Number.isFinite(parsedMonth) ? parsedMonth : now.month();

  return {
    year,
    month,
    period: createFinanceReportPeriod(year, month),
    needsCanonicalRedirect:
      !Number.isFinite(parsedYear) || !Number.isFinite(parsedMonth),
  };
}

export function financePeriodCanonicalRedirect(
  url: URL,
  year: number,
  month: number,
): Response {
  url.searchParams.set("year", String(year));
  url.searchParams.set("month", String(month));
  return redirect(`${url.pathname}?${url.searchParams.toString()}`);
}

export function parseFinancePeriodFromSearch(
  search: string,
  fallback: { year: number; month: number },
): FinancePeriod {
  const params = new URLSearchParams(search);
  const parsedYear = params.get("year");
  const parsedMonth = params.get("month");
  const year =
    parsedYear != null && Number.isFinite(Number(parsedYear))
      ? Number(parsedYear)
      : fallback.year;
  const month =
    parsedMonth != null && Number.isFinite(Number(parsedMonth))
      ? Number(parsedMonth)
      : fallback.month;

  return {
    year,
    month,
    period: createFinanceReportPeriod(year, month),
  };
}

export function buildFinanceActionPath(pathname: string, search: string): string {
  return `${pathname}${search}`;
}
